import React from "react";
import { Container, Row, Col } from "reactstrap";
// import { Icon } from '@iconify/react';
import { useSelector } from "react-redux";
import { dataUrl } from "../../../helpers/common";

const Features = () => {
  const keyFeature = useSelector(
    (state) => state.contents["aboutus_key_features"]
  );

  if (keyFeature?.length === 0) {
    return null
  }

  return (
    <React.Fragment>
      <section className='section'>
        <Container>
          <Row className='justify-content-center'>
            <Col lg={7}>
              <div className='section-title text-center mb-5'>
                <h3 className='title mb-3'>Key Features</h3>
                <p className='para-desc text-muted mx-auto'>
                  Your next job isn't just a role-it's your next step forward. <br/>
                  Join thousands of professionals using JobSeekers to land
                  interviews, connect with hiring managers, and access
                  career-boosting tools. The future of work is
                  here-let's go get it.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            {keyFeature?.map((featuresDetails, key) => (
              <Col lg={4} md={6} className='mt-4 pt-2' key={key}>
                <div className='about-feature p-3 d-flex align-items-center rounded-3'>
                  <div className='feature-icon flex-shrink-0'>
                    <img
                      className='key-feature-img'
                      src={`${dataUrl}/contents/${featuresDetails?.additional_fields?.image}`}
                      alt={featuresDetails.name}
                    />
                  </div>
                  <div className='flex-grow-1 ms-3'>
                    <h6 className='fs-18 mb-0'>{featuresDetails.name}</h6>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Features;
